
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Deployments</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="deployments[0]?.projectId &amp;&amp; deployments[0]?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: deployments[0]?.projectId}">{{ deployments[0]?.projectName }}</a></li>
        <li class="breadcrumb-item" *ngIf="deployments[0]?.siteId &amp;&amp; deployments[0]?.siteName"><a [routerLink]="['/sites']" [queryParams]="{projectId: deployments[0]?.projectId}">Sites</a></li>
        <li class="breadcrumb-item" *ngIf="siteId &amp;&amp; deployments[0]?.siteName"><a [routerLink]="['/site']" [queryParams]="{id: siteId}">{{ deployments[0]?.siteName }}</a></li>
        <li class="breadcrumb-item active" *ngIf="!siteId || !deployments[0]?.siteName">All</li>
        <li class="breadcrumb-item active">Deployments</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" href="javascript:void(0)" (click)="create()" [ngClass]="{'general-disabled': project?.isMigrationActive}">Create Deployment</a></list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [(ngModel)]="hideCompletedAssets" (change)="changeHideCompletedAssets()" autoLinkToLabel>
        <label class="form-check-label">Hide completed deployments</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">&nbsp;</div>
  </div>
  <div class="row" *ngFor="let deployment of deployments">
    <div class="col">
      <div class="card-item">
        <div class="card-progress-bar float-right">
          <div class="progress">
            <div class="progress-bar" role="progressbar" title="{{ deployment.deployedToK2PercentageBar.title }}" [ngClass]="deployment.deployedToK2PercentageBar.type" [style.width]="deployment.deployedToK2PercentageBar.width + '%'">{{deployment.deployedToK2PercentageBar.value + "%"}}</div>
          </div>
        </div>
        <h4>{{ deployment.name }}<span class="badge ml-1" *ngIf="deployment.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4>
        <property-container>
          <property-item><a [href]="'/#/deployment?id=' + deployment.id">Details</a></property-item>
          <property-item><a [href]="'/#/workflow/' + deployment.workflowId">Set Up Deployment</a></property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="deployment.deliveryDate">Delivery Date: {{ deployment.deliveryDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
          <property-item [showIf]="deployment.installDate">Install Date: {{ deployment.installDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
        </property-container>
        <property-container>
          <property-item>Assets: {{ deployment.plannedAssets }} planned, {{ deployment.deployedAssets }} deployed</property-item>
          <property-item>Accessories: {{ deployment.plannedAccessories }} planned, {{ deployment.deployedAccessories + deployment.deployedStandAloneAccessories}} deployed</property-item>
        </property-container>
        <property-container class="red">
          <property-item [showIf]="deployment.pastSchedule"><span class="oi oi-clock"></span> {{ deployment.pastScheduleMessage }}</property-item>
        </property-container>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>